/* eslint-disable */
export default {
  title: '地區',
  NAOnlyMessage: '請設定您的區碼。這將會供您的本地撥號使用。',
  MultiWithNAMessage:
    '請為您的地區設定國家代碼及區碼。這將會供本地撥號及電話號碼格式使用。',
  MultiWithoutNAMessage:
    '請為您的地區選擇國家代碼及區碼。這將會供本地撥號及電話號碼格式使用。',
  country: '國家/地區',
  areaCode: '區碼',
  areaCodePlaceholder: '輸入區碼',
} as const;

// @key: @#@"title"@#@ @source: @#@"Region"@#@
// @key: @#@"NAOnlyMessage"@#@ @source: @#@"Please set your area code. This will be used for local dialing."@#@
// @key: @#@"MultiWithNAMessage"@#@ @source: @#@"Please set the country and area code for your region. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"MultiWithoutNAMessage"@#@ @source: @#@"Please select the country you locate in. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"country"@#@ @source: @#@"Country"@#@
// @key: @#@"areaCode"@#@ @source: @#@"Area Code"@#@
// @key: @#@"areaCodePlaceholder"@#@ @source: @#@"Enter Area Code"@#@
